
import { delegate } from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/animations/shift-away.css';

document.addEventListener('DOMContentLoaded', () => {
    delegate('#app', {
        target: '[data-tooltip]',        
        content: (reference) => reference.dataset.tooltip,
        placement: 'top',
        maxWidth: 250,
        allowHTML: true,
        animation: 'shift-away',
        appendTo: document.getElementById('app'),
    });
});
